const commitsInfo = [
    {
        commitSha: "26545952:efcb8f54a30c95b795aa8e7195f2bb28d0cc7adc",
        directlyToMaster: false,
        title: "MVP-421: deployment baselines",
        projectId: "26545952",
        linesChanged: 436,
        datetime: "2022-05-11T09:54:45.000Z",
    },
    {
        commitSha: "26545952:63e9d5528a237571c817316f2c298f5fb5f9a088",
        directlyToMaster: false,
        title: "MVP-383: fixed scan pagination issue",
        projectId: "26545952",
        linesChanged: 15,
        datetime: "2022-05-11T14:35:49.000Z",
    },
    {
        commitSha: "26545952:2ca714cc85064eaf26a5c1d8248da03c52e277de",
        directlyToMaster: false,
        title: "MVP-421: fixed lint",
        projectId: "26545952",
        linesChanged: 6,
        datetime: "2022-05-11T16:56:37.000Z",
    },
    {
        commitSha: "26545952:8ed049c4bb9974c09d040bfa790d218e361fdd38",
        directlyToMaster: false,
        title: "MVP-421: fix deployment baseline daily stats",
        projectId: "26545952",
        linesChanged: 22,
        datetime: "2022-05-12T08:25:27.000Z",
    },
    {
        commitSha: "23559216:bf3a2977741a176ed63d5cb4fd575863ce560028",
        directlyToMaster: false,
        title: "MVP-421: fundamental baselines",
        projectId: "23559216",
        linesChanged: 186,
        datetime: "2022-05-12T09:00:30.000Z",
    },
    {
        commitSha: "31805602:d42c848008534db08536579cd0866e148b764140",
        directlyToMaster: false,
        title: "MVP-423: Integrate with work baselines",
        projectId: "31805602",
        linesChanged: 295,
        datetime: "2022-05-12T09:04:56.000Z",
    },
    {
        commitSha: "26545952:4e3667a0921d8c6cc6f9fa72da8428e260b65d08",
        directlyToMaster: false,
        title: "MVP-421: undo commenting out",
        projectId: "26545952",
        linesChanged: 1,
        datetime: "2022-05-12T09:07:43.000Z",
    },
    {
        commitSha: "26545952:5feb45d9a805664e9c913d81b7179430ab5ca5bc",
        directlyToMaster: false,
        title: "MVP-421: baselines deployment script added",
        projectId: "26545952",
        linesChanged: 19,
        datetime: "2022-05-12T09:09:14.000Z",
    },
    {
        commitSha: "26545952:202a1e3ce0f2bc4d2c0b40408ac7e4c90539d5e9",
        directlyToMaster: false,
        title: "MVP-421: debugged baselines results",
        projectId: "26545952",
        linesChanged: 73,
        datetime: "2022-05-12T13:11:23.000Z",
    },
    {
        commitSha: "31805602:27f4369990d906bd68481bc516e6e2081b2ff8ca",
        directlyToMaster: false,
        title: "MVP-423: fix baseline tooltip crashing when no baseline",
        projectId: "31805602",
        linesChanged: 6,
        datetime: "2022-05-12T13:15:24.000Z",
    },
    {
        commitSha: "23559216:6d75dd8c2da0085d149b090842cc8997b3933b02",
        directlyToMaster: false,
        title: "MVP-421: fixed test",
        projectId: "23559216",
        linesChanged: 359,
        datetime: "2022-05-12T13:22:31.000Z",
    },
    {
        commitSha: "23559216:f053f8a3e567b69cd05bda771f6346a525781bca",
        directlyToMaster: false,
        title: "MVP-419: change when xray is used to check for environment name",
        projectId: "23559216",
        linesChanged: 5,
        datetime: "2022-05-12T13:27:44.000Z",
    },
    {
        commitSha: "29537981:8503cd514b4b28f5eedf3ba8572bbf2ded752430",
        directlyToMaster: false,
        title: "MVP-424: CloudFront automatic bundle compression",
        projectId: "29537981",
        linesChanged: 5,
        datetime: "2022-05-12T14:23:23.000Z",
    },
    {
        commitSha: "29537981:048a4966c652a7d3faa4e8da601ec75096d22c20",
        directlyToMaster: false,
        title: "MVP-424: grafana auth token",
        projectId: "29537981",
        linesChanged: 1,
        datetime: "2022-05-12T14:35:17.000Z",
    },
    {
        commitSha: "26545952:0ce5856fabbc16fe4342478b9dc7c191948ea7f2",
        directlyToMaster: false,
        title: "MVP-421: add xray to baselines",
        projectId: "26545952",
        linesChanged: 3,
        datetime: "2022-05-12T14:42:04.000Z",
    },
    {
        commitSha: "29537981:0d1ba55d9d0e6ce77800086356bf39209c0e04c0",
        directlyToMaster: false,
        title: "MVP-424: grafana auth token",
        projectId: "29537981",
        linesChanged: 1,
        datetime: "2022-05-12T14:45:52.000Z",
    },
    {
        commitSha: "29537981:cff2c977a1fa1849e23a239a210007c7cd2a4c51",
        directlyToMaster: false,
        title: "MVP-424: remove ForwardedValues from cache behaviour",
        projectId: "29537981",
        linesChanged: 8,
        datetime: "2022-05-12T14:55:23.000Z",
    },
    {
        commitSha: "23559216:5c07d07ab90bdde8d2c5d5c3bab8011af4e9d52e",
        directlyToMaster: false,
        title: "MVP-421: change greater than to between in dynamo query",
        projectId: "23559216",
        linesChanged: 3,
        datetime: "2022-05-16T11:22:42.000Z",
    },
    {
        commitSha: "29537981:624fa9e6a8874e0c47966a390f69f79d7b30d161",
        directlyToMaster: false,
        title: "MVP-421: add baselines to step function",
        projectId: "29537981",
        linesChanged: 29,
        datetime: "2022-05-16T12:16:21.000Z",
    },
    {
        commitSha: "26545952:5a3cd90464472d99787f87ea1929b9550f646b92",
        directlyToMaster: false,
        title: "MVP-421: 368->381",
        projectId: "26545952",
        linesChanged: 1,
        datetime: "2022-05-16T10:31:56.000Z",
    },
    {
        commitSha: "26545952:2a23e78276ecc8e6aa06f74932f4bcbf23a3e50b",
        directlyToMaster: false,
        title: "MVP-416: MR fundamentals calculation first commit",
        projectId: "26545952",
        linesChanged: 375,
        datetime: "2022-05-18T10:14:01.000Z",
    },
    {
        commitSha: "26545952:5675fefa50574b73815e590ed405ec37e4e70123",
        directlyToMaster: false,
        title: "MVP-421: address review comments",
        projectId: "26545952",
        linesChanged: 31,
        datetime: "2022-05-18T12:28:37.000Z",
    },
    {
        commitSha: "26545952:bacab58c679ffbdece03eaa27d7977667251accc",
        directlyToMaster: true,
        title: "MVP-421: fix getFundamentalType return type",
        projectId: "26545952",
        linesChanged: 1,
        datetime: "2022-05-18T18:15:36.000Z",
    },
];

const commitsPerDay = [
    {
        datetime: "2021-11-30T15:26:51.000Z",
        value: 4,
        baseline: 3,
    },
    {
        datetime: "2021-12-01T15:26:51.000Z",
        value: 6,
        baseline: 3,
    },
    {
        datetime: "2021-12-01T15:26:51.000Z",
        value: 9,
        baseline: 7,
    },
    {
        datetime: "2021-12-02T15:26:51.000Z",
        value: 2,
        baseline: 3,
    },
    {
        datetime: "2021-12-03T15:26:51.000Z",
        value: 4,
        baseline: 5,
    },
    {
        datetime: "2021-12-04T15:26:51.000Z",
        value: 5,
        baseline: 3,
    },
    {
        datetime: "2021-12-05T15:26:51.000Z",
        value: 6,
        baseline: 3,
    },
];

const changesPerLanguage = [
    {
        language: "JavaScript",
        commits: 32,
        lines: 3234,
        baseline: {
            commits: 10,
            lines: 534,
        },
    },
    {
        language: "TypeScript",
        commits: 32,
        lines: 4323,
        baseline: {
            commits: 17,
            lines: 885,
        },
    },
    {
        language: "Ada",
        commits: 3,
        lines: 489,
        baseline: {
            commits: 6,
            lines: 269,
        },
    },
];

const codeSegmentation = [
    {
        datetime: "2021-11-29T10:40:45.000Z",
        additions: 52,
        deletions: 107,
        modifications: 17,
        total: 159,
        baseline: {
            additions: 50,
            deletions: 100,
            modifications: 10,
            total: 150,
        },
    },
    {
        datetime: "2021-11-30T15:26:51.000Z",
        additions: 252,
        deletions: 10,
        modifications: 10,
        total: 262,
        baseline: {
            additions: 252,
            deletions: 10,
            modifications: 10,
            total: 262,
        },
    },
    {
        datetime: "2021-12-01T15:26:51.000Z",
        additions: 68,
        deletions: 0,
        modifications: 0,
        total: 68,
        baseline: {
            additions: 68,
            deletions: 0,
            modifications: 10,
            total: 68,
        },
    },
    {
        datetime: "2021-12-02T15:26:51.000Z",
        additions: 352,
        deletions: 0,
        modifications: 32,
        total: 352,
        baseline: {
            additions: 352,
            deletions: 0,
            modifications: 10,
            total: 352,
        },
    },
    {
        datetime: "2021-12-03T15:26:51.000Z",
        additions: 543,
        deletions: 4,
        modifications: 10,
        total: 547,
        baseline: {
            additions: 543,
            deletions: 4,
            modifications: 10,
            total: 547,
        },
    },
    {
        datetime: "2021-12-04T15:26:51.000Z",
        additions: 352,
        modifications: 10,
        deletions: 31,
        total: 383,
        baseline: {
            additions: 352,
            deletions: 31,
            modifications: 10,
            total: 383,
        },
    },
    {
        datetime: "2021-12-05T15:26:51.000Z",
        additions: 46,
        modifications: 10,
        deletions: 47,
        total: 93,
        baseline: {
            additions: 46,
            deletions: 47,
            modifications: 10,
            total: 93,
        },
    },
];

const linesPerDay = [
    {
        datetime: "2022-10-18T00:00:00.000Z",
        value: 295,
        baseline: 266.09,
    },
    {
        datetime: "2022-10-19T00:00:00.000Z",
        value: 129,
        baseline: 370.38,
    },
    {
        datetime: "2022-10-20T00:00:00.000Z",
        value: 273,
        baseline: 383.66,
    },
    {
        datetime: "2022-10-21T00:00:00.000Z",
        value: 108,
        baseline: 417.55,
    },
    {
        datetime: "2022-10-22T00:00:00.000Z",
        value: 0,
        baseline: 0,
    },
    {
        datetime: "2022-10-23T00:00:00.000Z",
        value: 0,
        baseline: 0,
    },
    {
        datetime: "2022-10-24T00:00:00.000Z",
        value: 198,
        baseline: 212.7,
    },
];

const stats = {
    directlyToMasterCount: 1,
    projects: ["26545", "29216", "37981", "318002", "253788"],
    averageCommitSize: 1265,
    totalLinesChanged: 4948,
    totalCommits: 21,
    projectCount: 6,
};

const statsBaseline = {
    directlyToMasterCount: 3,
    projectCount: 5.5,
    averageCommitSize: 1005,
    totalLinesChanged: 3948,
    totalCommits: 18,
};

const getCommits = () => {
    return {
        commitsInfo,
        commitsPerDay,
        changesPerLanguage,
        codeSegmentation,
        linesPerDay,
        stats,
        statsBaseline,
    };
};

export default getCommits;
